<div class="table-responsive rounded border" style="background: #ffffff; border-color: #e2e8f0 !important;" *ngIf="receiptData">
  <table class="table table-hover table-striped mb-0" style="font-size: 0.8125rem;">
    <thead style="background: var(--theme-primary, #123c53); color: #ffffff;">
      <tr>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Type</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Charges Head</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Account</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Amount</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Collection On</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Collection By</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Narration</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of receiptData">
        <td class="font-weight-bold text-dark">{{ row.Type }}</td>
        <td class="text-dark">{{ row.ChagesHead }}</td>
        <td class="text-dark">{{ row.Account }}</td>
        <td class="font-weight-bold text-danger">₹{{ row.Amount }}</td>
        <td class="text-dark">{{ row.CollectionOn }}</td>
        <td class="text-dark">{{ row.CollectionBy }}</td>
        <td class="text-muted small">{{ row.Narration || '-' }}</td>
      </tr>
    </tbody>
  </table>
</div>